/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface ConfirmEmailRequestDto
 */
export interface ConfirmEmailRequestDto {
    /**
     * 
     * @type {string}
     * @memberof ConfirmEmailRequestDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConfirmEmailRequestDto
     */
    token?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConfirmEmailRequestDto
     */
    newPassword?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConfirmEmailRequestDto
     */
    $type?: ConfirmEmailRequestDtoTypeEnum;
}


/**
 * @export
 */
export const ConfirmEmailRequestDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedAuthorizationAccountDtoConfirmEmailRequestDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Authorization.Account.Dto.ConfirmEmailRequestDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type ConfirmEmailRequestDtoTypeEnum = typeof ConfirmEmailRequestDtoTypeEnum[keyof typeof ConfirmEmailRequestDtoTypeEnum];


/**
 * Check if a given object implements the ConfirmEmailRequestDto interface.
 */
export function instanceOfConfirmEmailRequestDto(value?: unknown): value is ConfirmEmailRequestDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ConfirmEmailRequestDtoTypeEnum)[0];
}

export function ConfirmEmailRequestDtoFromJSON(json: any): ConfirmEmailRequestDto {
    return ConfirmEmailRequestDtoFromJSONTyped(json, false);
}

export function ConfirmEmailRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfirmEmailRequestDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': !exists(json, 'email') ? undefined : json['email'],
        'token': !exists(json, 'token') ? undefined : json['token'],
        'newPassword': !exists(json, 'newPassword') ? undefined : json['newPassword'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function ConfirmEmailRequestDtoToJSON(value?: ConfirmEmailRequestDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'email': value.email,
        'token': value.token,
        'newPassword': value.newPassword,
        '$type': value.$type,
    });
}

